module.exports = __webpack_public_path__ + "img/cristiano-ronaldo.c55678a6.png";